






























import {
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  useContext,
  computed
} from "@nuxtjs/composition-api";
import { useUiState } from "~/composables";
import { useCart } from "~/modules/checkout/composables/useCart";
import { useUiNotification } from "~/composables";

export default defineComponent({
  components: {},
  props: {
    title: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { app } = useContext();
    const { loadTotalQty: loadCartTotalQty, cart } = useCart();
    const { toggleCartSidebar, isCartSidebarOpen } = useUiState();
    const router = app.router;

    const isSticky = ref(false);
    const activeTab = ref('description');
    const tabWasClicked = ref(false);
    let scrollTimeout = null;

    const handleScroll = () => {
      isSticky.value = window.scrollY > 100;
      
      if (tabWasClicked.value) {
        if (scrollTimeout) {
          clearTimeout(scrollTimeout);
        }
        
        scrollTimeout = setTimeout(() => {
          tabWasClicked.value = false;
        }, 1000);
      } else {
        updateActiveTabOnScroll();
      }
    };

    const updateActiveTabOnScroll = () => {
      if (tabWasClicked.value) return;
      
      const descriptionElement = document.getElementById('product-description');
      const storeElement = document.querySelector('.product__actions__stores--mobile');
      const recommendationsElement = document.querySelector('.product-related-container');
      
      const scrollPosition = window.scrollY + 120;
      
      if (descriptionElement && storeElement && recommendationsElement) {
        const descriptionPosition = descriptionElement.getBoundingClientRect().top + window.scrollY;
        const storePosition = storeElement.getBoundingClientRect().top + window.scrollY;
        const recommendationsPosition = recommendationsElement.getBoundingClientRect().top + window.scrollY;
        
        if (scrollPosition >= recommendationsPosition) {
          activeTab.value = 'recommendations';
        } else if (scrollPosition >= storePosition) {
          activeTab.value = 'store';
        } else if (scrollPosition >= descriptionPosition) {
          activeTab.value = 'description';
        }
      }
    };

    const { send: sendNotification } = useUiNotification();

    const back = () => {
      if (window.history.length > 1) {
        router.back();
      } else {
        const routerQuery = router.currentRoute.query;
        const routerData = router.resolve({
          path: `${app.localePath("/")}`,
          query: {
            ...routerQuery,
          },
        });
        window.history.replaceState({}, null, routerData.href);
      }
    };

    const share = () => {
      if (navigator.share) {
        const shareData = {
          title: props.title,
          text: '',
          url: window.location.href,
        };

        navigator.share(shareData)
          .catch((error) => console.log('Lỗi khi chia sẻ:', error));
      } else {
        sendNotification({
          id: Symbol("share-product-detail"),
          message: "Trình duyệt của bạn không hỗ trợ API chia sẻ.",
          type: "warning",
          icon: "info",
          persist: false,
        });

      }
    };

    const scrollToDescription = () => {
      activeTab.value = 'description';
      tabWasClicked.value = true;
      
      const element = document.getElementById('product-description');
      if (element) {
        const rect = element.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const offsetPosition = rect.top + scrollTop;
        
        const headerOffset = 100;
        
        window.scrollTo({
          top: offsetPosition - headerOffset,
          behavior: 'smooth'
        });
      }
    };

    const scrollToStore = () => {
      activeTab.value = 'store';
      tabWasClicked.value = true;
      
      const storeElement = document.querySelector('.product__actions__stores--mobile');
      if (storeElement) {
        const rect = storeElement.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const offsetPosition = rect.top + scrollTop;
        
        const headerOffset = 180;
        
        window.scrollTo({
          top: offsetPosition - headerOffset,
          behavior: 'smooth'
        });
      }
    };

    const scrollToRecommendations = () => {
      activeTab.value = 'recommendations';
      tabWasClicked.value = true;
      
      const storeElement = document.querySelector('.product-related-container');
      if (storeElement) {
        const rect = storeElement.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const offsetPosition = rect.top + scrollTop;
        
        const headerOffset = 180;
        
        window.scrollTo({
          top: offsetPosition - headerOffset,
          behavior: 'smooth'
        });
      }
    };

    onMounted(async () => {
      await loadCartTotalQty();
      window.addEventListener("scroll", handleScroll);
      // Initial check to set the correct active tab on page load
      setTimeout(updateActiveTabOnScroll, 500);
    });

    onUnmounted(() => {
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      window.removeEventListener("scroll", handleScroll);
    });

    return {
      cartTotalItems: computed(() => cart.value?.total_quantity ?? 0),
      toggleCartSidebar,
      isCartSidebarOpen,
      back,
      isSticky,
      share,
      activeTab,
      scrollToDescription,
      scrollToStore,
      scrollToRecommendations
    };
  }
});
